import './i18n';
import {Route, Routes, useSearchParams} from "react-router-dom";
import Main from "./page/Main";
import Impressum from "./page/Impressum";
import Datenschutz from "./page/Datenschutz";

function App() {
    return (
        <Routes>
            <Route index element={<Main/>}/>
            <Route path={"/impressum"} element={<Impressum/>}/>
            <Route path={"/datenschutz"} element={<Datenschutz/>}/>
        </Routes>
    )
}

export default App;
